import React from 'react';
import { 
  Clock, 
  Shield, 
  Sparkles, 
  Wrench,
  CheckCircle2,
  AlertTriangle,
  Heart,
  Timer,
  Brush,
  Calendar,
  Stethoscope,
  Award
} from 'lucide-react';
import './Dto43c2.css';

const Dto43c2: React.FC = () => {
  return (
    <div className="dto43c2">
      {/* Hero Section */}
      <div className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Expert Ceramic Veneer Care</h1>
          <p>Your Guide to Long-lasting, Beautiful Smiles</p>
        </div>
      </div>

      {/* Treatment Options Section */}
      <section className="options-section container">
        <h2 className="section-title">Treatment Options</h2>
        <div className="options-grid">
          <div className="option-card">
            <Timer className="option-icon" />
            <h3>One-Day Digital Veneers</h3>
            <p>
              Quick digital scanning and same-day fabrication using advanced 3D technology. 
              Ideal for those seeking immediate results.
            </p>
            <ul className="option-features">
              <li>Digital oral scanning</li>
              <li>Same-day completion</li>
              <li>Computer-aided design</li>
            </ul>
          </div>
          
          <div className="option-card highlight">
            <Award className="option-icon" />
            <h3>Haute Custom Veneers</h3>
            <p>
              Premium customized veneers crafted by expert technicians for the ultimate 
              in natural aesthetics and precision fit.
            </p>
            <ul className="option-features">
              <li>Expert craftsmanship</li>
              <li>Customized smile design</li>
              <li>Superior aesthetics</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Maintenance Guide */}
      <section className="maintenance-section">
        <div className="container">
          <h2 className="section-title">Essential Maintenance Guide</h2>
          <div className="maintenance-grid">
            <div className="maintenance-card">
              <Brush className="maintenance-icon" />
              <h3>Daily Care</h3>
              <p>
                Maintain excellent oral hygiene with proper brushing and flossing, 
                treating veneers like natural teeth.
              </p>
            </div>
            
            <div className="maintenance-card">
              <AlertTriangle className="maintenance-icon" />
              <h3>Avoid Hard Foods</h3>
              <p>
                Protect your veneers by avoiding extremely hard foods and not using 
                teeth as tools.
              </p>
            </div>
            
            <div className="maintenance-card">
              <Shield className="maintenance-icon" />
              <h3>Night Protection</h3>
              <p>
                Use a night guard if you grind your teeth to prevent wear and 
                maintain veneer integrity.
              </p>
            </div>
            
            <div className="maintenance-card">
              <Calendar className="maintenance-icon" />
              <h3>Regular Check-ups</h3>
              <p>
                Schedule regular dental visits for professional cleaning and 
                veneer maintenance.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Longevity Section */}
      <section className="longevity-section container">
        <div className="longevity-content">
          <div className="longevity-text">
            <h2>Long-Term Success</h2>
            <p>
              With proper care and maintenance, ceramic veneers can last 20-30 years 
              or more. Our advanced techniques and premium materials ensure maximum 
              durability and aesthetic longevity.
            </p>
            <ul className="longevity-features">
              <li>
                <CheckCircle2 className="feature-icon" />
                <span>Ultra-thin design (0.1-0.3mm)</span>
              </li>
              <li>
                <CheckCircle2 className="feature-icon" />
                <span>Maximum natural tooth preservation</span>
              </li>
              <li>
                <CheckCircle2 className="feature-icon" />
                <span>Superior bonding technology</span>
              </li>
            </ul>
          </div>
          <div className="longevity-image">
            <img 
              src="https://images.unsplash.com/photo-1581594693702-fbdc51b2763b?auto=format&fit=crop&q=80&w=1500"
              alt="Long-lasting Smile"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <h2 className="section-title">Common Questions</h2>
          <div className="faq-grid">
            <div className="faq-card">
              <Stethoscope className="faq-icon" />
              <h3>Pre-Treatment Requirements</h3>
              <p>
                Orthodontic treatment may be recommended based on your specific dental 
                condition and goals. A thorough evaluation determines the best approach.
              </p>
            </div>
            
            <div className="faq-card">
              <Shield className="faq-icon" />
              <h3>Decay Prevention</h3>
              <p>
                While veneers protect the front surface, maintaining good oral hygiene 
                is essential to prevent decay at the margins and underlying tooth structure.
              </p>
            </div>
            
            <div className="faq-card">
              <Clock className="faq-icon" />
              <h3>Treatment Duration</h3>
              <p>
                Custom veneers typically require 2-3 visits, while same-day options 
                can be completed in a single appointment.
              </p>
            </div>
            
            <div className="faq-card">
              <Wrench className="faq-icon" />
              <h3>Maintenance Requirements</h3>
              <p>
                Regular dental check-ups and good oral hygiene practices are essential 
                for maintaining your veneers' appearance and longevity.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Professional Care */}
      <section className="professional-section container">
        <div className="professional-content">
          <h2 className="section-title">Expert Care Promise</h2>
          <div className="professional-grid">
            <div className="professional-card">
              <Heart className="professional-icon" />
              <h3>Personalized Attention</h3>
              <p>
                Every treatment plan is customized to meet your specific needs and 
                aesthetic goals, ensuring optimal results.
              </p>
            </div>
            
            <div className="professional-card">
              <Sparkles className="professional-icon" />
              <h3>Advanced Technology</h3>
              <p>
                We utilize state-of-the-art digital scanning and design technology 
                for precise, predictable results.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dto43c2;